var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.desc,style:({
    borderColor: _vm.theme.borderColor,
  })},[(_vm.theme.titleType !== 'none')?_c('div',{class:_vm._.hd,style:({
      marginTop: _vm.$transformPx(_vm.theme.titleTop),
    })},[_c('img',{class:_vm._.title,attrs:{"src":_vm.theme.title}})]):_vm._e(),_c('div',{class:_vm._.bd},[_c('div',{ref:"content",class:[_vm._.content, 'ql-editor'],style:(Object.assign({}, (_vm.canFold && _vm.isFold
          ? {
              height: (_vm.foldHeight + "px"),
              overflow: 'hidden',
            }
          : undefined))),domProps:{"innerHTML":_vm._s(_vm.data[0].title)}}),(_vm.canFold)?_c('div',{class:_vm._.more,style:({
        color: _vm.theme.openFontColor,
      }),on:{"click":function($event){_vm.isFold = !_vm.isFold}}},[(_vm.isFold)?[_vm._v(" 展开"),_c('van-icon',{class:_vm._.icon,attrs:{"name":"arrow-down"}})]:[_vm._v(" 收起"),_c('van-icon',{class:_vm._.icon,attrs:{"name":"arrow-up"}})]],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }